<template>
    <div>
        <v-layout>
            <v-flex>
                <div id="reportList" v-if="display=='report'">
                    <v-layout wrap>
                        <v-flex xs12 sm12 md12 lg12 xl12 style="margin: auto">
                            <div id="divStudents">
                                <v-data-table :headers="reportHeaders" :items="reports" class="elevation-1"
                                              hide-actions>
                                    <template slot="items" slot-scope="props">
                                        <td class="text-xs-left">{{ props.index +1 }}</td>
                                        <td class="text-xs-left">{{getReportType( props.item.reportType )}}</td>
                                        <td class="text-xs-left">{{ props.item.reportName }}</td>
                                        <td class="text-xs-left" v-if="$store.state.auth.user.role!=2">{{ props.item.reportDate | formatDateTime }}</td>
                                        <td class="text-xs-left" v-if="$store.state.auth.user.role!=2">{{ getReportStatus(props.item.status)}}</td>
                                        <td class="justify-center layout px-0">
                                            <v-btn @click="viewReport(props.item)" class="mx-0" icon>
                                                <v-icon class="primaryColor">visibility</v-icon>
                                            </v-btn>
                                            <v-btn @click="updateReport(props.item)" class="mx-0" icon v-if="$store.state.auth.user.role==4">
                                                <v-icon color="pink">edit</v-icon>
                                            </v-btn>
                                        </td>
                                    </template>
                                </v-data-table>
                            </div>
                        </v-flex>
                    </v-layout>
                </div>
                <div id="memberList" v-else-if="display=='list'">
<!--                    <v-layout class="reportPanel">
                        <v-flex xs4 sm4 md4 lg4 xl4 style="text-align: center;">
                            <div class="label">
                                ĐIỂM TRUNG BÌNH
                            </div>
                            <div class="content" style="font-size: 50px;font-weight: bold">
                                {{averateMark}}
                            </div>
                        </v-flex>
                        <v-flex xs8 sm8 md8 lg8 xl8>
                            <canvas id="mark-lesson-report-chart"/>
                        </v-flex>
                    </v-layout>-->
                    <v-layout>
                        <v-flex xs12 sm12 md12 lg12 xl12 class="yocontent">
                            <div style="text-align: center;font-weight: bold">KẾT QUẢ HỌC TẬP - Môn {{reportMeta.class.disciplineName}}</div>
                            <div style="text-align: center">Tháng {{reportMeta.month}} Năm {{reportMeta.year}}</div>
                            <div>Lớp: {{reportMeta.class.className}}</div>
                            <div>Giáo viên: {{reportMeta.teacher}}</div>
                            <div>Học sinh điểm xếp hạng nhất lớp: {{reportMeta.firstStudent}}</div>
                            <div>Học sinh điểm xếp hạng nhì lớp: {{reportMeta.secondStudent}}</div>
                            <div>Tốp 5 học sinh tiến bộ: {{reportMeta.improvement}}</div>

                            <v-data-table :headers="detailReportHeaders" class="elevation-1"
                                          :items="reportData" hide-actions locale="vi">
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-right">{{ props.index+1}}</td>
                                    <td class="text-xs-left">{{ props.item["fullName"] }}</td>
                                    <td class="text-xs-right">{{ props.item["completedPercent"] }}</td>
                                    <td class="text-xs-right">{{ props.item["markAverage"] }}</td>
                                    <td class="text-xs-right">
                                        <div v-if="editReport==false">
                                            {{ props.item["markReward"] }}
                                        </div>
                                        <input class="tableInput" v-else type="text" style="text-align: right"
                                               v-model='props.item["markReward"]'/>

                                    </td>
                                    <td class="text-xs-right" v-if="editReport==false">{{ props.item["markTotal"]}}</td>
                                    <td class="text-xs-right" v-if="editReport==false">{{ props.item["markPreviousMonth"]}}</td>
                                    <td class="text-xs-right" v-if="editReport==false">{{ props.item["markDifference"]}}</td>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                    <div style="text-align: right">
                        <v-btn color="primary" @click="onExportReport">
                            {{$t('lang.common.exportReport') }}
                        </v-btn>
                        <v-btn class="blue" dark @click="onSend" v-if="!editReport && $store.state.auth.user.role==4">
                            {{$t('lang.class.send')}}
                        </v-btn>
                        <v-btn class="yoprimary" dark @click="editReport = true" v-if="!editReport && $store.state.auth.user.role==4">
                            {{$t('lang.common.edit')}}
                        </v-btn>
                        <v-btn @click="saveReport()" v-if="editReport && $store.state.auth.user.role==4"
                               class="yoprimary" dark>
                            {{$t('lang.common.save')}}
                        </v-btn>
                        <v-btn @click="closeDetail()" color="red" dark>
                            {{$t('lang.common.back')}}
                        </v-btn>
                    </div>
                </div>
                <send-to-member :class-id="classId" @send="onChangeReceiver" ref="sendDialog" :selectable="false"/>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import axios from "axios";
    import {message} from "@/shared/message";
    import SendToMember from "../sendToMember";

    export default {
        name: "monthly-report-page",
        components: {SendToMember},
        props: {
            classId: {
                type: String | Number,
                default: null
            }
        },

        data: () => ({
            display: "report",
            editReport: false,
            year:null,
            month:null,
            studentHeaders: [
                {
                    text: "Sinh viên",
                    align: "left",
                    sortable: false,
                    value: "fullName"
                },
                {
                    text: "email",
                    align: "left",
                    sortable: false,
                    value: "email"
                },
                {text: "Báo cáo chi tiết", value: "name", align: "center", sortable: false}
            ],
            students: [],
            reportData: [],
            workingReport: null,
            reports: [],
            reportMeta:{},
            exerciseId: null,
            exerciseType: null,
            averateMark: null,
        }),

        computed: {
            detailReportHeaders: function(){
                if(this.editReport){
                    return [
                        {
                            text: "STT",
                            align: "left",
                            sortable: false,
                            value: "index"
                        },
                        {
                            text: "HỌ TÊN",
                            align: "left",
                            sortable: false,
                            value: "fullName"
                        },
                        {
                            text: "TỈ LỆ HOÀN THÀNH BÀI TẬP",
                            align: "right",
                            sortable: false,
                            value: "completedPercent"
                        },
                        {
                            text: "ĐIỂM TRUNG BÌNH",
                            align: "right",
                            sortable: false,
                            value: "markAverage"
                        },
                        {
                            text: "ĐIỂM THƯỞNG",
                            align: "left",
                            sortable: false,
                            value: "markReward"
                        }
                    ]
                } else {
                    return [
                        {
                            text: "STT",
                            align: "right",
                            sortable: false,
                            value: "index"
                        },
                        {
                            text: "HỌ TÊN",
                            align: "left",
                            sortable: false,
                            value: "fullName"
                        },
                        {
                            text: "TỈ LỆ HOÀN THÀNH BÀI TẬP",
                            align: "right",
                            sortable: false,
                            value: "completedPercent"
                        },
                        {
                            text: "ĐIỂM TRUNG BÌNH",
                            align: "right",
                            sortable: false,
                            value: "markAverage"
                        },
                        {
                            text: "ĐIỂM THƯỞNG",
                            align: "right",
                            sortable: false,
                            value: "markReward"
                        },
                        {
                            text: "ĐIỂM XẾP HẠNG",
                            align: "right",
                            sortable: false,
                            value: "teacherCommentImprove"
                        },
                        {
                            text: "ĐIỂM XẾP HẠNG THÁNG TRƯỚC",
                            align: "right",
                            sortable: false,
                            value: "markPreviousMonth"
                        },
                        {
                            text: "CHÊNH LỆCH",
                            align: "right",
                            sortable: false,
                            value: "markPreviousMonth"
                        }
                    ]
                }
            },
            reportHeaders(){
                if(this.$store.state.auth.user.role==2){
                    return [
                        {
                            text: "STT",
                            align: "left",
                            sortable: false,
                            value: "index"
                        },
                        {
                            text: "Loại báo cáo",
                            align: "left",
                            sortable: false,
                            value: "reportType"
                        },
                        {
                            text: "Tên báo cáo",
                            align: "left",
                            sortable: false,
                            value: "reportName"
                        },
                        {
                            text: "Xử lý",
                            align: "center",
                            sortable: false,
                            value: "status"
                        }
                    ];
                } else {
                    return [
                        {
                            text: "STT",
                            align: "left",
                            sortable: false,
                            value: "index"
                        },
                        {
                            text: "Loại báo cáo",
                            align: "left",
                            sortable: false,
                            value: "reportType"
                        },
                        {
                            text: "Tên báo cáo",
                            align: "left",
                            sortable: false,
                            value: "reportName"
                        },
                        {
                            text: "Thời gian cập nhật",
                            align: "left",
                            sortable: false,
                            value: "reportDate"
                        },
                        {
                            text: "Trạng thái",
                            align: "left",
                            sortable: false,
                            value: "status"
                        },
                        {
                            text: "Xử lý",
                            align: "center",
                            sortable: false,
                            value: "status"
                        }
                    ];
                }
            }
        },

        watch: {
            classId: function (data) {
                this.getReportList();
            },
            month: function (data) {
                //console.log(data);
            }
        },

        created() {
            //this.getReportList();
        },
        methods: {
            getReportType: function (type) {
                let typeName = "";
                switch (type) {
                    case 0:
                        typeName = "Báo cáo sau bài tập";
                        break;
                    case 1:
                        typeName = "Báo cáo cá nhân";
                        break;
                    case 2:
                        typeName = "Báo cáo tháng";
                        break;
                    case 3:
                        typeName = "Báo cáo quý";
                        break;
                }
                return typeName;
            },
            getReportStatus: function (status) {
                let name = "";
                switch (status) {
                    case 0:
                        name = "Chưa cập nhật";
                        break;
                    case 1:
                        name = "Đã cập nhật";
                        break;
                    case 2:
                        name = "Đã gửi";
                        break;
                }
                return name;

            },

            getReportList: function () {
                if (this.classId == null) {
                    return;
                }
                axios
                    .post(
                        process.env.VUE_APP_API_URL +
                        "/report/listMonthlyReport?classId=" +
                        this.classId
                    )
                    .then(
                        data => {
                            this.reports = data;
                        },
                        error => {
                        }
                    )

            },

            viewReport: function (report) {
                this.year = report.year;
                this.month = report.month;
                this.editReport = false;
                this.display = "list";
                this.workingReport = report;
                this.getMarkReport();
            },

            updateReport: function (report) {
                this.year = report.year;
                this.month = report.month;
                this.editReport = true;
                this.display = "list";
                this.workingReport = report;
                this.getMarkReport();
            },

            getMarkReport: function () {
                axios.post(process.env.VUE_APP_API_URL + "/report/getMonthlyReport?classId=" + this.classId + "&year=" + this.year + "&month=" + this.month)
                    .then(
                        data => {
                            this.reportData = data.lstData;
                            this.reportMeta = data;
                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            onExportReport: function () {
                let url = process.env.VUE_APP_API_URL + "/report/downloadMonthlyReport?classId=" + this.classId + "&year=" + this.year + "&month=" + this.month;
                window.location.href = url;
            },

            saveReport: function () {
                axios.post(process.env.VUE_APP_API_URL + "/report/saveMonthlyReportData", this.reportData)
                    .then(
                        data => {
                            if (data.success) {
                                axios.post(process.env.VUE_APP_API_URL + "/report/saveReport?", this.workingReport).then(
                                    saveResult => {
                                        if (saveResult.success) {
                                            message.success(this.$t('lang.common.save_success'));
                                            this.workingReport = saveResult.ref;
                                            this.editReport = false;
                                            this.getMarkReport();
                                        }
                                    },

                                    saveError => {
                                        message.error(saveError);

                                    }
                                );

                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    )

            },

            closeDetail: function () {
                this.display = "report";
                this.getReportList();
            },

            onSendEmail: function () {
                axios.post(process.env.VUE_APP_API_URL + "/report/sendMonthlyEmailReport?classId=" + this.classId + "&year=" + this.year + "&month=" + this.month)
                    .then(
                        data => {
                            if (data.success) {
                                message.success("Gửi mail thành công");
                            } else {
                                message.error("Gửi mail không thành công");
                            }

                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            onSendSMS: function () {
                axios.post(process.env.VUE_APP_API_URL + "/report/sendMonthlySMSReport?classId=" + this.classId + "&year=" + this.year + "&month=" + this.month)
                    .then(
                        data => {
                            if (data.success) {
                                message.success("Gửi SMS thành công");
                            } else {
                                message.error("Gửi SMS không thành công");
                            }

                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            onSendZalo: function () {
                //let url = encodeURIComponent("https://localhost:8082/#/sendZalo/");
                let url = process.env.VUE_APP_FRONTEND_URL + "/#/sendZalo";
                let state = this.classId + "_" + this.year + "_" + this.month+"_month";
                url = encodeURIComponent(url);
                //console.log(url);
                window.location.href = "https://oauth.zaloapp.com/v3/permission?app_id=2865613710705099529&redirect_uri=" + url + "&state=" + state;
            },

            onSend: function(){
                this.$refs.sendDialog.show();
            },

            onChangeReceiver: function(receivers){
                axios.post(process.env.VUE_APP_API_URL+"/report/sendReport",this.workingReport).then(
                    data=>{
                        if(data.success){
                            this.onSendEmail();
                            this.onSendSMS();
                            //this.onSendZalo();
                            this.workingReport = data.ref;
                        }
                    }
                )
            },
        }
    };
</script>